import { Component, Inject, OnInit } from "@angular/core";
import { Validators, FormBuilder } from "@angular/forms";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";

@Component({
  selector: "app-insert-client-logo",
  templateUrl: "./insert-client-logo.component.html",
  styleUrls: ["./insert-client-logo.component.scss"],
})
export class InsertClientLogoComponent implements OnInit {
  public logoBase64: string = null;
  logoForm = this.fb.group({
    logo: [null, Validators.required],
  });

  constructor(
    public dialogRef: MatDialogRef<InsertClientLogoComponent>,
    @Inject(MAT_DIALOG_DATA) public data,
    private fb: FormBuilder
  ) {}

  ngOnInit(): void {
    // this.logoForm.patchValue(this.data);
  }

  onSubmit() {
    const formValue = this.logoForm.value;
    this.dialogRef.close(formValue);
  }

  closeCancelling() {
    this.dialogRef.close();
  }

  handleFileInput(file) {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      this.logoBase64 = reader.result.toString();
      this.logoForm.patchValue({
        logo: this.logoBase64.split(",")[1], // Manipolazione delicata.
      });
    };
  }
}
